import { createStyledBreakpointsTheme } from 'styled-breakpoints'

export const getPrimaryTheme = (colorMode: 'light' | 'dark', tenant: Tenant) =>
  ({
    colorMode: colorMode,
    color: {
      background: colorMode === 'light' ? '#ffffff' : '#121212',
      backgroundInverted: colorMode === 'dark' ? '#ffffff' : '#222426',
      text: colorMode === 'light' ? '#202346' : '#ffffff',
      textInverted: colorMode === 'dark' ? '#202346' : '#ffffff',
      main: colorMode === 'light' ? '44, 162, 159' : '44, 162, 159',
      grey: colorMode === 'light' ? '228, 230, 234' : '60, 62, 66',
      tenant:
        colorMode === 'light'
          ? tenant.key === '24heures'
            ? '#d9000b'
            : tenant.key === 'tdg'
            ? '#2c3890'
            : '#0a79bd'
          : '#ffffff',
    },
  } as const)

export const getTheme = (colorMode: 'light' | 'dark', tenant: Tenant) => ({
  ...getPrimaryTheme(colorMode, tenant),
  ...createStyledBreakpointsTheme({
    breakpoints: {
      xs: '0px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px',
      xxl: '1400px',
      xxxl: '1580px',
    },
  }),
})
